module.exports = __webpack_public_path__ + "static/img/today_area_best_team.93509f72.png";